











































import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'GSiteHeader',
  props: {
    menuVisibility: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    // headerLogoImageUrl: {
    //   type: String as PropType<string>,
    //   default: '',
    // },
    // headerLogoLinkUrl: {
    //   type: String as PropType<string>,
    //   default: '',
    // },
    menuFlg: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  computed: {
    favoriteUrl(): string {
      if (this.$auth.isAnonymous) { return '/web/auth/signup?at=1'; }
      if (this.$auth.isExhibitor) { return '/web/auth/signin'; }
      return '/web/buyer/favorites';
    },
    contactUrl(): string {
      if (this.$auth.isAnonymous) { return '/web/auth/signup?at=1'; }
      if (this.$auth.isExhibitor) { return '/web/exhibitor/contact'; }
      return '/web/buyer/contact';
    },
  },
  methods: {
    onMenu() {
      this.$emit('menu');
    },
  },
});
